// queryClient.js
import {QueryClient} from 'react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            cacheTime: 1000 * 60 * 60, // 1 hour
            refetchOnWindowFocus: true,
        },
    },
});